import { useCallback } from 'react'

import { AuthenticationResponse, SuccessResult } from '~/redux/apis/types'
import { LoginType } from '~/analytics/account/accountEvents.types'

import useCheckSubscriptionAndBookingStatus from './useSubscriptionAndBookingStatus'
import useHandleOnLoginSuccess from './useHandleOnLoginSuccess'
import useLoginUser from './useLoginUser'

interface Params {
  result: SuccessResult<AuthenticationResponse>
  loginType: LoginType
  loginAfterSignup: boolean
  isSubscriptionCheckout?: boolean
}

type ReturnType = (params: Params) => void

export default function useSessionAndLoginRedirection(): ReturnType {
  const addUserSession = useLoginUser()
  const { runCallbackWithSubscriptionAndBookingStatus } = useCheckSubscriptionAndBookingStatus()
  const handleOnLoginSuccess = useHandleOnLoginSuccess()

  const setSessionAndLoginRedirection: ReturnType = useCallback(
    (params) => {
      const { loginType, result } = params
      const { user } = result.data
      addUserSession({ loginType, result })

      runCallbackWithSubscriptionAndBookingStatus(user, (isSubscriptionRequired) =>
        handleOnLoginSuccess({ ...params, isSubscriptionRequired }),
      )
    },
    [addUserSession, handleOnLoginSuccess, runCallbackWithSubscriptionAndBookingStatus],
  )

  return setSessionAndLoginRedirection
}
